import { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { Button, Card, Col, Row, Modal } from "antd"; // ✅ thêm Modal
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import { getOtherType, deleteOtherType } from "../../../redux/action/otherType";
import { Product_Banner } from "../../../utils/formatType";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

const { confirm } = Modal; // ✅ FIX QUAN TRỌNG

function BannerProduct() {
  const { t } = useTranslation();
  const { otherTypeList } = useSelector((state) => state.otherType);

  const [loading, setLoading] = useState(true);

  /* ================= FETCH DATA ================= */
  const fetchData = async () => {
    try {
      setLoading(true);
      await dispatch(getOtherType(Product_Banner));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= DELETE ================= */
  const handleDelete = (e: React.MouseEvent, id: number) => {
    e.preventDefault(); // ⛔ chặn Link
    e.stopPropagation(); // ⛔ chặn bubble

    confirm({
      title: "Xác nhận xoá",
      content: "Bạn có chắc chắn muốn xoá banner này không?",
      okText: "Xoá",
      okType: "danger",
      cancelText: "Huỷ",
      onOk: async () => {
        try {
          await dispatch(deleteOtherType(id));
          fetchData(); // reload list
        } catch (error) {
          console.error(error);
        }
      },
    });
  };

  /* ================= RENDER ================= */
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <TitleComponent
            title="Banner sản phẩm"
            type="primary"
            data="Tạo mới"
            icon={<PlusOutlined />}
            to="/Product/Banner/Create"
            isExist={true}
          />

          {otherTypeList.map((item, index) => (
            <Link to={`/Product/Banner/${item.id}`} key={item.id}>
              <Card className="layoutItem" style={{ marginBottom: 16 }}>
                <h3 style={{ color: "var(--primary-color)", marginBottom: 8 }}>
                  Banner {index + 1}
                </h3>

                <Row gutter={[20, 20]}>
                  {/* TEXT */}
                  <Col xs={24} md={12}>
                    <div>
                      <p className="tilteForm">{t("title")}</p>
                      <p className="descForm">{item.title}</p>
                    </div>

                    <div style={{ marginTop: 16 }}>
                      <p className="tilteForm">{t("Mô tả")}</p>
                      <p className="descForm" style={{ minHeight: 90 }}>
                        {item.description}
                      </p>
                    </div>

                    <Button
                      style={{ marginTop: 30 }}
                      type="primary"
                      
                      onClick={(e) => {
                        if (!item.id) return;
                        handleDelete(e, item.id);
                      }}
                    >
                      Xoá Banner
                    </Button>
                  </Col>

                  {/* IMAGE */}
                  <Col xs={24} md={12}>
                    {item.images?.[0] ? (
                      <img
                        src={item.images[0]}
                        alt="banner"
                        style={{
                          width: "100%",
                          height: 280,
                          borderRadius: 10,
                          marginTop: 14,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: 180,
                          marginTop: 14,
                          borderRadius: 10,
                          background: "#f0f0f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#999",
                          fontStyle: "italic",
                        }}
                      >
                        Không có ảnh
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            </Link>
          ))}
        </>
      )}
    </div>
  );
}

export default BannerProduct;
